import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay"]

  disconnect() {
    this.close()
  }

  toggle() {
    if (!this.hasSidebarTarget) return

    if (this.sidebarTarget.classList.contains("is-open")) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    if (!this.hasSidebarTarget) return

    this.sidebarTarget.classList.add("is-open")
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("is-visible")
    }
    document.body.classList.add("sidebar-open")
  }

  close() {
    if (this.hasSidebarTarget) {
      this.sidebarTarget.classList.remove("is-open")
    }
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("is-visible")
    }
    document.body.classList.remove("sidebar-open")
  }

  closeOnEscape() {
    if (this.hasSidebarTarget && this.sidebarTarget.classList.contains("is-open")) {
      this.close()
    }
  }
}
